import { render } from "./DynamicComponentActionElement.vue.js?vue&type=template&id=28142c8c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentActionElement.vue?vue&type=template&id=28142c8c"
import script from "./DynamicComponentActionElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentActionElement.vue?vue&type=script&lang=js"
export * from "./DynamicComponentActionElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentActionElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28142c8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28142c8c', __exports__)) {
    api.reload('28142c8c', __exports__)
  }
  
  module.hot.accept("./DynamicComponentActionElement.vue.js?vue&type=template&id=28142c8c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentActionElement.vue?vue&type=template&id=28142c8c", () => {
    api.rerender('28142c8c', render)
  })

}


export default __exports__